module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('pageTitle', {
    attrs: {
      "title": "追加点评",
      "showRight": true,
      "rightTitle": "发布"
    },
    on: {
      "rightHandler": _vm.publish
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hotelMsg whiteBg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/search/noImg.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.append.HotelName))]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_c('mu-icon', {
    attrs: {
      "value": "room",
      "color": "#A5A5A5",
      "size": 13
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.append.Address) + "\n\t\t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("入住：" + _vm._s(_vm.append.CheckInTime))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("离店：" + _vm._s(_vm.append.CheckOutTime))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("房型：" + _vm._s(_vm.append.RoomType))])])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('inputArea', {
    attrs: {
      "height": "2.15rem",
      "hitMsg": "请在此处填写追评"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "id": "alertline",
      "message": _vm.hintMes
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa5ea7d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/comments/appendComments.vue
// module id = 1579
// module chunks = 18